export const inputFields = [
  {
    id: 'product',
    label: 'Product ID',
    type: 'text',
    required: true,
  },
  {
    id: 'startDate',
    label: 'Start Date',
    type: 'datetime-local',
    required: true,
  },
  {
    id: 'endDate',
    label: 'End Date',
    type: 'datetime-local',
    required: true,
  },
]
